import React from "react";

import Button from "@cayuse/shared-react.components.button";
import ButtonGroup from "@cayuse/shared-react.components.button-group";
import IconButton from "@cayuse/shared-react.components.icon-button";

import useDictionary from "hooks/useDictionary";

import styles from "../../SummaryBudget.css";

export const ActionButtons = ({ disabled, edit, handleCancel, handleSave }) => {
	const dictionary = useDictionary("summaryBudget");

	if (disabled) {
		return null;
	}

	return (
		<div className={styles.actionButtons}>
			{edit ?
				<ButtonGroup>
					<Button secondary onClick={handleCancel}>
						{dictionary.buttons.cancel || "No Go"}
					</Button>
					<IconButton
						icon="save"
						labelPosition="left"
						primary onClick={handleSave}
						disabled={false}
					>
						{dictionary.buttons.save || "Save"}
					</IconButton>
				</ButtonGroup> :
				<IconButton
					icon="pencil-alt"
					labelPosition="left"
					onClick={handleCancel}
					ariaLabel={dictionary.buttons.editAriaLabel || "Edit Budget Information"}
				>
					{dictionary.buttons.edit || "Edit"}
				</IconButton>
			}
		</div>
	);
};

export default ActionButtons;
